import type { ProjectModel, ScannerReconciliation } from "../types.js";

export function scanReconciliation(
  readme: string | null,
  project: ProjectModel
): ScannerReconciliation {
  const content = readme ?? "";

  const documentedCommands = project.commands.filter((command) =>
    isCommandDocumented(content, command)
  );
  const undocumentedCommands = project.commands.filter(
    (command) => !documentedCommands.includes(command)
  );

  const workspacePaths = project.workspaces.map((workspace) => workspace.path);
  const documentedWorkspaces = workspacePaths.filter((workspacePath) =>
    content.includes(workspacePath)
  );
  const undocumentedWorkspaces = workspacePaths.filter(
    (workspacePath) => !documentedWorkspaces.includes(workspacePath)
  );

  return {
    documentedCommands,
    undocumentedCommands,
    documentedWorkspaces,
    undocumentedWorkspaces,
  };
}

function isCommandDocumented(content: string, command: string): boolean {
  const [scope, script] = command.split(":");
  if (!scope || !script) return false;

  if (
    content.includes(`npm run ${script}`) ||
    content.includes(`pnpm ${script}`) ||
    content.includes(`pnpm run ${script}`) ||
    content.includes(`yarn ${script}`) ||
    content.includes(`bun run ${script}`) ||
    content.includes(`turbo run ${script}`) ||
    content.includes(`make ${script}`)
  ) {
    return true;
  }

  if (scope === "root") {
    return content.includes(`\`${script}\``) || content.includes(`"${script}"`);
  }

  return content.includes(`${scope}:${script}`) || content.includes(`${scope} ${script}`);
}
